<script lang="ts" setup>
  defineProps<{ paused?: boolean }>();
</script>

<template>
  <div :class="{ paused }" class="spinner">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<style scoped>
  .spinner {
    color: var(--color-primary);
    display: inline-block;
    height: 50px;
    position: relative;
    width: 50px;
  }

  .spinner div {
    animation: spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border: 4px solid transparent;
    border-radius: var(--radius-full);
    border-top-color: currentcolor;
    display: block;
    height: 80%;
    margin: 10%;
    position: absolute;
    width: 80%;
  }

  .spinner.paused div {
    animation-play-state: paused;
  }

  .spinner div:nth-child(1) {
    animation-delay: -0.45s;
  }

  .spinner div:nth-child(2) {
    animation-delay: -0.3s;
  }

  .spinner div:nth-child(3) {
    animation-delay: -0.15s;
  }

  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
</style>
